import { TEAM_PRODUCT_PRICING_RECEIVED } from '../../actions/product-management/GetTeamProduct';
import { PRICING_RECEIVED } from '../../actions/product-management/GetProductMeta';

const initialState = {
  all: {
    currencies: {},
    discount_types: {},
    licenseables: {},
    periods: {},
    limits: {
      checks: {},
      subjects: {},
    },
  },
};

const pricing = (state = initialState, action) => {
  switch (action.type) {
    case TEAM_PRODUCT_PRICING_RECEIVED: // Deliberate fall through of case
    case PRICING_RECEIVED:
      return Object.assign({}, state, {
        all: action.all,
      });
  }

  return state;
};

export default pricing;
